export const NAV_ICON_NAMES = [
    "House", "Grid", "ShoppingCart", "Service", "Goods", "Promotion",
    "Document", "DataAnalysis", "Setting", "Bell", "User", "Collection",
    "Calendar", "Wallet", "Search", "Link"
];
export const NAV_PERMISSION_OPTIONS = [
    "workbench.platform.admin", "workbench.identity.admin", "workbench.product.admin",
    "workbench.workflow.admin", "workbench.integration.admin", "crmeb.system.admin",
    "bytedesk.system.admin"
];
export const NAV_ROUTE_OPTIONS = [
    { path: "/", label: "我的工作台", description: "工作总览与常用入口" },
    { path: "/tasks", label: "我的待办", description: "待处理事项与审批" },
    { path: "/alerts", label: "异常提醒", description: "消息与异常通知" },
    { path: "/integrations", label: "应用中心", description: "查看系统连接状态" },
    { path: "/apps/store", label: "进入商城", description: "商品、订单与会员管理" },
    { path: "/apps/customer-service/online/current", label: "在线客服", description: "查看和处理会话" },
    { path: "/apps/customer-service/manage/workgroups", label: "客服管理", description: "客服组织与接待配置" },
    { path: "/products", label: "产品台账", description: "产品主档与状态" },
    { path: "/product-initiatives", label: "新品立项", description: "发起新品计划" },
    { path: "/lifecycle", label: "生命周期看板", description: "跟踪产品阶段" },
    { path: "/sku-batches", label: "SKU 与生产批次", description: "管理商品及批次映射" },
    { path: "/marketing/plans", label: "宣发计划", description: "营销计划与节点" },
    { path: "/marketing/calendar", label: "任务日历", description: "查看营销日程" },
    { path: "/marketing/assets", label: "素材与参考链接", description: "集中管理素材" },
    { path: "/marketing/templates", label: "模板管理", description: "维护营销模板" },
    { path: "/approvals", label: "待我审批", description: "处理待批事项" },
    { path: "/applications", label: "我的申请", description: "跟踪申请进度" },
    { path: "/expenses", label: "费用台账", description: "查阅费用记录" },
    { path: "/budgets", label: "预算", description: "预算占用与提醒" },
    { path: "/analysis/profit", label: "产品毛利", description: "分析产品贡献" },
    { path: "/analysis/sales", label: "销售与退款", description: "核对销售数据" },
    { path: "/analysis/costs", label: "成本待确认", description: "跟踪成本核算" },
    { path: "/system/staff", label: "组织与职员", description: "管理组织和员工" },
    { path: "/system/roles", label: "角色权限", description: "分配账号权限" },
    { path: "/system/workflows", label: "审批流程", description: "配置审批规则" },
    { path: "/system/integration-logs", label: "集成与日志", description: "查看集成记录" },
    { path: "/system/navigation", label: "导航菜单配置", description: "调整菜单与展示位置" },
    { path: "/knowledge", label: "知识手册", description: "工作台使用资料" },
    { path: "/help", label: "帮助中心", description: "常见问题与支持" }
];
const child = (id, path, label, description, icon, order, permissionCode) => ({ id, path, label, description, icon, order, enabled: true, ...(permissionCode ? { permissionCode } : {}) });
export const DEFAULT_NAVIGATION = [
    { id: "work", label: "工作台", description: "日常事务", icon: "House", order: 10, placement: "left", enabled: true, children: [
            child("dashboard", "/", "我的工作台", "工作总览与常用入口", "House", 10),
            child("tasks", "/tasks", "我的待办", "集中处理待办事项", "Document", 20),
            child("alerts", "/alerts", "异常提醒", "查看消息和异常", "Bell", 30)
        ] },
    { id: "store", label: "商城", description: "商品与订单", icon: "ShoppingCart", order: 20, placement: "top", enabled: true, systemCode: "crmeb", children: [
            child("store-entry", "/apps/store", "进入商城", "商品、订单与会员管理", "ShoppingCart", 10)
        ] },
    { id: "customer", label: "客服", description: "在线接待与管理", icon: "Service", order: 30, placement: "top", enabled: true, systemCode: "bytedesk", children: [
            child("customer-online", "/apps/customer-service/online/current", "在线客服", "查看和处理会话", "Service", 10),
            child("customer-manage", "/apps/customer-service/manage/workgroups", "客服管理", "客服组织与接待配置", "User", 20)
        ] },
    { id: "products", label: "产品中心", description: "产品与批次", icon: "Goods", order: 40, placement: "left", enabled: true, children: [
            child("products-list", "/products", "产品台账", "产品主档与状态", "Goods", 10),
            child("products-new", "/product-initiatives", "新品立项", "发起新品计划", "Grid", 20),
            child("products-lifecycle", "/lifecycle", "生命周期看板", "跟踪产品阶段", "DataAnalysis", 30),
            child("products-sku", "/sku-batches", "SKU 与生产批次", "管理商品及批次映射", "Collection", 40)
        ] },
    { id: "marketing", label: "营销中心", description: "推广与内容", icon: "Promotion", order: 50, placement: "left", enabled: true, children: [
            child("marketing-plans", "/marketing/plans", "宣发计划", "营销计划与节点", "Promotion", 10),
            child("marketing-calendar", "/marketing/calendar", "任务日历", "查看营销日程", "Calendar", 20),
            child("marketing-assets", "/marketing/assets", "素材与参考链接", "集中管理素材", "Collection", 30),
            child("marketing-templates", "/marketing/templates", "模板管理", "维护营销模板", "Document", 40)
        ] },
    { id: "approvals", label: "审批与费用", description: "申请与预算", icon: "Wallet", order: 60, placement: "left", enabled: true, children: [
            child("approvals-pending", "/approvals", "待我审批", "处理待批事项", "Document", 10),
            child("approvals-applications", "/applications", "我的申请", "跟踪申请进度", "Collection", 20),
            child("approvals-expenses", "/expenses", "费用台账", "查阅费用记录", "Wallet", 30),
            child("approvals-budgets", "/budgets", "预算", "预算占用与提醒", "DataAnalysis", 40)
        ] },
    { id: "analysis", label: "经营分析", description: "经营指标", icon: "DataAnalysis", order: 70, placement: "left", enabled: true, children: [
            child("analysis-profit", "/analysis/profit", "产品毛利", "分析产品贡献", "DataAnalysis", 10),
            child("analysis-sales", "/analysis/sales", "销售与退款", "核对销售数据", "ShoppingCart", 20),
            child("analysis-costs", "/analysis/costs", "成本待确认", "跟踪成本核算", "Wallet", 30)
        ] },
    { id: "system", label: "系统管理", description: "权限与配置", icon: "Setting", order: 80, placement: "left", enabled: true, children: [
            child("system-staff", "/system/staff", "组织与职员", "管理组织和员工", "User", 10, "workbench.identity.admin"),
            child("system-roles", "/system/roles", "角色权限", "分配账号权限", "Setting", 20, "workbench.identity.admin"),
            child("system-workflows", "/system/workflows", "审批流程", "配置审批规则", "Document", 30, "workbench.workflow.admin"),
            child("system-logs", "/system/integration-logs", "集成与日志", "查看集成记录", "Link", 40, "workbench.integration.admin"),
            child("system-navigation", "/system/navigation", "导航菜单配置", "调整菜单与展示位置", "Grid", 50, "workbench.platform.admin")
        ] }
];
//# sourceMappingURL=navigation.js.map